const EventSentenceFilter = function($filter) {
  return function(event, fullName, linkToUser){
    var displayName = '';

    if(event.user){
      displayName = event.user.first_name;

      if(fullName)
        displayName += ' ' + event.user.last_name;

      if(linkToUser && event.homeId && event.agentId)
        displayName = '<a ui-sref="agent.homeDetail({homeId:event.homeId,id:event.agentId})">' + displayName + '</a>';
    }

    if(event.event === 'client-add-home') {
      return displayName + ' added a home to their profile.';
    }

    if(event.source === 'mandrill'){

      if(event.event === 'click')
        return displayName + ' clicked on the email.';
      if(event.event === 'view')
        return displayName + ' viewed the digest from the email.';
      if(event.event === 'open')
        return displayName + ' opened the email.';
      if(event.event === 'sent')
        return 'Digest was emailed to ' + displayName + '.';
      if(event.event === 'spam')
        return displayName + ' marked the digest as spam.';
      if(event.event === 'soft_bounce' || event.event === 'hard_bounce')
        return 'Digest was sent to ' + displayName + ', but the email bounced.';
      if(event.event === 'reject')
        return 'Digest was sent to ' + displayName + ', but the email was rejected.';
      if(event.event === 'equity-opportunity-sent')
        return 'Equity email was sent to ' + displayName + '.';
      if(event.event === 'equity-opportunity-open')
        return displayName + ' opened the equity email.';
      if(event.event === 'equity-opportunity-click')
        return displayName + ' clicked on the equity email.';
      if(event.event === 'home-market-sent')
        return 'Home market report was emailed to ' + displayName + '.';
      if(event.event === 'home-market-open')
        return displayName + ' opened their home market email.';
      if(event.event === 'home-market-click')
        return displayName + ' clicked on their home market email.';

    } else if(event.source === 'sms') {

      if(event.event === 'view')
        return displayName + ' viewed the digest from the text message';

    } else if(event.source === 'twilio'){

      if(event.event === 'view' || event.event === 'open') // our twilio open event is deprecated,safe to remove 9/15
        return displayName + ' clicked on the text message.';
      if(event.event === 'sent')
        return 'Digest was texted to ' + displayName + '.';

    } else if(event.source === 'agent'){

      //event.amount and event.diff are available
      if(event.event === 'avm-up')
        return 'You raised the value of ' + displayName + '\'s home by ' + $filter('money')(event.diff) + ' with a new CMA.';
      if(event.event === 'avm-down')
        return 'You lowered the value of ' + displayName + '\'s home by ' + $filter('money')($filter('abs')(event.diff)) + ' with a new CMA.';
      if(event.event === 'cma-notify-client')
        return 'You notified ' + displayName + ' of the CMA.';

    } else if(event.source === 'homebot'){

      //event.amount and event.diff are available
      if(event.event === 'avm-up')
        return displayName + '\'s AVM went up ' + $filter('money')(event.diff) + ' for the month.';
      if(event.event === 'avm-down')
        return displayName + '\'s AVM went down ' + $filter('money')($filter('abs')(event.diff)) + ' for the month.';
      if(event.event === 'loan-new')
        return 'A new loan was added for ' + displayName + '.';
      if(event.event === 'RT_migration')
        return displayName + '\'s AVM and history were updated to Homebot\'s new algorithm.';
      if(event.event === 'shifted-to-monthly-digests')
        return displayName + ' has re-engaged with Homebot emails and is back on a monthly send schedule!';
      if(event.event === 'shifted-to-quarterly-digests')
        return displayName + ' hasn\'t looked at their Homebot emails in six months so has been moved to a quarterly email.';
      if(event.event === 'client-referral-sign-up')
        return `${event.properties.referred_client_name} signed up for Homebot from a referral by ${displayName}`;
    } else if(event.source === 'user'){

      if(event.event === 'cma-request')
        return 'CMA Requested by '+ displayName + '.';

      if(event.event === 'view')
        return displayName + ' viewed the digest.';

      if(event.event === 'messageAgent' || event.event === 'homeowner-direct-message') {

        if(event.properties && event.properties.topic && event.properties.message)
          return displayName + ` wants to know more about ${event.properties.topic}: "${event.properties.message}"`;

        return displayName + ' sent you a message.';
      }

      if(event.event === 'mortgage-coach-tca-requested') {
        if(event.properties) {
          if(event.properties.loan_params.loan_term_years) {
            if(event.properties.loan_params.loan_type === 'ARM') {
              return `TCA requested by ${displayName} for a ${event.properties.loan_params.arm_years_initial}/1-arm refi.`
            }
            return `TCA requested by ${displayName} for a ${event.properties.loan_params.loan_term_years}-year refi.`
          }
          return `TCA requested by ${displayName}.`
        }
      }

      if(event.event === 'mortgage-coach-tca-updated') {
        if(event.properties) {
          if(event.properties.loan_params.loan_term_years) {
            if(event.properties.loan_params.loan_type === 'ARM') {
              return `${displayName} added a ${event.properties.loan_params.arm_years_initial}/1-arm refi scenario to their TCA.`
            }
            return `${displayName} added a ${event.properties.loan_params.loan_term_years}-year refi scenario to their TCA.`
          }
        }
      }

      if(event.event === 'sms-subscribe')
        return `${displayName} enabled text updates.`;

      if(event.event === 'sms-unsubscribe')
        return `${displayName} disabled text updates.`;

      if(event.event === 'homeInsuranceCovered')
        return displayName + ' explored home insurance options.';

      if(event.event === 'viewed-dream-home-panel')
        return displayName + ' viewed the new home panel.';

      if(event.event === 'viewed-home-insurance-panel')
        return displayName + ' explored more details on home insurance.';

      if(event.event === 'refiSliderInteraction')
        return displayName + ' explored refi timelines.';

      if(event.event === 'viewedRefiDetails')
        return displayName + ' explored more details on a refi option.';

      if(event.event === 'viewed-market-panel')
        return displayName + ' viewed home\'s market stats.';

      if(event.event === 'referral-invite-sent')
        return `${displayName} shared Homebot with a friend`;

      if(event.event === 'updated-loan-balance') {
        if(event.properties && event.properties.balance_diff && event.properties.balance) {
          const balanceDiff = parseInt(event.properties.balance_diff);
          const extraOrLess = balanceDiff > 0 ? 'extra' : 'less';

          return `${displayName}  updated their loan balance to ${$filter('money')(event.properties.balance)}. This means they have paid a total of ${$filter('money')($filter('abs')(balanceDiff))} ${extraOrLess} towards principal over the life of the loan`;
        }
      }

      if(event.event === 'instant-offer-requested') {
        return `${displayName} requested to learn more about instant offers`;
      }

      if (event.event === 'client-tuned-value') {
        if (event.properties && event.properties.valuation_amount) {

          return `${displayName} tuned their value to ${$filter('money')(event.properties.valuation_amount)}.`
        }
      }

      if(event.event === 'client-updated-mobile-number') {
        return `${displayName} updated their phone number.`;
      }

      if(event.event === 'updated-insurance-policy-start-date') {
        if (event.properties && event.properties.date) {
          const date = moment(event.properties.date).format('MM/DD/YYYY');

          return `${displayName} updated their home insurance policy start date to ${date}`;
        }

        return `${displayName} updated their home insurance policy details`;
      }
    }

    return '';
  };
};

if(typeof module !== 'undefined' && module.exports){
  module.exports = EventSentenceFilter;
} else if(typeof window !== 'undefined'){
  window.EventSentenceFilter = EventSentenceFilter;
}
